import {useCallback, useEffect} from 'react';
import {shallowEqual} from 'react-redux';
import {useAppDispatch, useAppSelector} from 'store/customer';
import {
    clearChangesByType,
    Type as ConfirmationType,
    selectChangesByType,
} from 'store/customer/appSlice';
import {setProductDataLoading} from 'components/customer/Product/store/productSlice';
import {useUnsavedChangesDialog} from 'shared/components/ConfirmationDialog/UnsavedChangesDialog';
import {useNavigationBlocker} from 'shared/components/ConfirmationDialog/useNavigationBlocker';

interface NavigationConfirmationProps {
    types: ConfirmationType[];
}

export const NavigationConfirmation = ({
    types,
}: NavigationConfirmationProps) => {
    const dispatch = useAppDispatch();
    const changes = useAppSelector(
        (state) => types.flatMap((type) => selectChangesByType(state, type)),
        shallowEqual
    );
    const hasChanges = changes.length > 0;

    const {dialog, showDialog, hideDialog} = useUnsavedChangesDialog();
    const {isBlocked, confirmNavigation, cancelNavigation} =
        useNavigationBlocker(hasChanges);

    const resetPageDirty = useCallback(() => {
        types.forEach((type) => {
            dispatch(clearChangesByType(type));
        });
    }, [types, dispatch]);

    useEffect(() => {
        if (!isBlocked) {
            hideDialog();
            return;
        }

        showDialog({
            onCancel: () => {
                cancelNavigation();
                dispatch(setProductDataLoading(false));
            },
            onConfirmDiscard: () => {
                resetPageDirty();
                confirmNavigation();
            },
        });
    }, [isBlocked]);

    return dialog;
};
